<template>
    <modal
        name="pay-with-como-points"
        height="auto"
        width="575"
        :maxWidth="575"
        :adaptive="true"
        :scrollable="true"
        :clickToClose="false"
        :pivotY="pivotY"
        :reset="true"
        transition="pop-out"
        :class="{ 'mobile-item-modal': pivotY === 1 }"
        @before-open="beforeOpen"
    >
        <div class="item-modal-content relative flex flex-col w-full">
            <div class="item-modal-body">
                <div
                    class="item-modal-details flex-auto p-6 pb-1 overflow-y-auto"
                >
                    <div class="relative block w-full pb-3 shadow-sm">
                        <h4
                            class="font-heading text-xl font-bold text-subheading"
                        >
                            {{ $t('comoRewards.payWithPoints') }}
                        </h4>
                        <div class="absolute right-0 top-0">
                            <button
                                type="button"
                                class="text-primary transition duration-150 ease-in-out hover:text-gray-500 focus:text-gray-500 focus:outline-none"
                                @click="hide"
                            >
                                <close-icon />
                            </button>
                        </div>
                    </div>

                    <div v-if="!comoMemberBalance">
                        <vue-content-loading
                            :height="48"
                            :speed="2"
                            class="mb-3"
                            primaryColor="#f3f3f3"
                            secondaryColor="#ecebeb"
                        >
                            <rect
                                x="2.5%"
                                y="10"
                                rx="3"
                                ry="3"
                                width="95%"
                                height="40"
                            />
                        </vue-content-loading>
                    </div>
                    <div class="flex flex-col py-4 px-2" v-else>
                        <div class="text-lg font-medium">
                            {{ $t('comoRewards.availablePoints') }}
                            <span class="text-primary">{{
                                (comoMemberBalance / 100).toFixed(2)
                            }}</span>
                        </div>

                        <div class="flex mt-4 items-center">
                            <input
                                type="checkbox"
                                id="payFull"
                                class="optin-checkbox form-checkbox h-4 w-4 cursor-pointer rounded border-gray-200 transition duration-150 ease-in-out focus:border-blue-200 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                v-model="payFull"
                                @change="setFullAmount"
                            />

                            <label
                                for="payFull"
                                class="font-medium text-sm text-gray-600 ml-2"
                            >
                                {{ $t('comoRewards.payFullAmount') }} ({{
                                    (maxAmount / 100).toFixed(2) | currency
                                }})
                            </label>
                        </div>

                        <div class="flex mt-4 items-center">
                            <label
                                for="paymentAmount"
                                class="font-medium text-sm text-gray-600 mr-4"
                                >{{ $t('comoRewards.enterAmountToPay') }}
                            </label>

                            <currency-input
                                v-model="amount"
                                id="paymentAmount"
                                class="form-input block w-1/3 bg-transparent border focus:border-blue-300 border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 shadow-sm resize-none transition duration-150 ease-in-out"
                                placeholder="1.00"
                                autocomplete="off"
                                :currency="null"
                                locale="en-GB"
                                :value-as-integer="true"
                                :allow-negative="false"
                                @blur="validateAmount"
                            ></currency-input>
                        </div>
                    </div>
                </div>
                <div
                    class="item-modal-footer flex flex-col-reverse justify-center p-6 md:flex-row"
                >
                    <base-button
                        class="p-3 px-10 mb-3 sm:block sm:mb-0 md:w-auto"
                        size="sm"
                        variant="secondaryActions"
                        :button-text="$t('comoRewards.close')"
                        :is-border-transparent="true"
                        @clicked="hide"
                    />
                    <base-button
                        class="px-12 py-4 sm:mb-3 mb-0 md:ml-6 md:w-auto"
                        size="sm"
                        :button-text="$t('comoRewards.apply')"
                        @clicked="apply"
                    />
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CurrencyInput } from 'vue-currency-input';
import VueContentLoading from 'vue-content-loading';

import isMobile from '@/helpers/isMobileDevice';
import CloseIcon from '@/components/icons/CloseIcon';

export default {
    name: 'pay-with-como-points-modal',
    components: { CloseIcon, VueContentLoading, CurrencyInput },
    props: {
        comoMemberBalance: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            amount: 1,
            payFull: false
        };
    },

    computed: {
        ...mapState({
            totalWithDiscount: state => state.cart.totalWithDiscount
        }),
        pivotY() {
            return isMobile() ? 1 : 0.5;
        },
        maxAmount() {
            return Math.min(this.totalWithDiscount, this.comoMemberBalance);
        }
    },
    methods: {
        ...mapActions({
            cartTotalWithDiscount: 'cart/cartTotalWithDiscount'
        }),
        setFullAmount() {
            if (this.payFull) {
                this.amount = this.maxAmount;
            }
        },
        hide() {
            this.$modal.hide('pay-with-como-points');
        },
        beforeOpen() {
            this.$emit('get-como-member-balance');
        },
        validateAmount() {
            if (this.amount < 1) {
                this.amount = 1;
            }

            if (this.amount > this.maxAmount) {
                this.amount = this.maxAmount;
            }
        },
        apply() {
            this.validateAmount();

            this.$store.commit('customer/SET_COMO_DATA', {
                paymentAmount: this.amount
            });

            this.cartTotalWithDiscount();
            this.hide();
        }
    }
};
</script>

<style scoped>
.optin-checkbox {
    color: #172d48;
    color: var(--color-bg-button, #292a31);
}
</style>
